import request from '@/utils/request';

/**
 * @description: 文章接口
 */

// 人才政策分类
export const talentPolicyCate = (data) => {
  return request.get('api/Res.TalentPolicyCatagory/index', { params: data });
};

// 人才政策列表
export const talentPolicyList = (data) => {
  return request.get('api/Res.TalentPolicy/index', { params: data });
};

// 人才政策详情页
export const talentPolicyDetail = (data) => {
  return request.get('api/Res.TalentPolicy/view', { params: data });
};

// 风采一览列表
export const imgList = (data) => {
  return request.get('api/Res.Image/index', { params: data });
};

// 风采一览详情页（未使用）
export const imgDetail = (data) => {
  return request.get('api/Res.Image/view', { params: data });
};

// 模板下载列表
export const templateList = (data) => {
  return request.get('api/Res.Template/index', { params: data });
};

// 模板下载详情页（未使用）
export const templateDetail = (data) => {
  return request.get('api/Res.Template/view', { params: data });
};

// 模板下载增加下载次数
export const templateAddDownloads = (data) => {
  return request.get('api/Res.Template/add_downloads', { params: data });
};

// 联系方式详情页
export const contactDetail = (data) => {
  return request.get('api/Res.Contact/view', { params: data });
};

// 网站信息
export const websiteInfo = (data) => {
  return request.get('api/Res.Frament/index?limit=20&page=1', { params: data });
};

// 网站导航栏分类
export const websiteNavCate = (data) => {
  return request.get('api/Res.Menu/index?limit=20&page=1', { params: data });
}
